module.exports = __webpack_public_path__ + "static/img/06-2.7ea5dcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue11/01/06-2.jpg
// module id = dj6G
// module chunks = 7